const MissionsSearchForm = () => import("@/components/MissionsSearchForm/MissionsSearchForm.vue")
import { mapGetters } from "vuex";
export default {
  components: {
    MissionsSearchForm,
  },
  computed:{
    ...mapGetters('auth', {
      generalSetting : 'generalSetting'
    })
  },
  methods: {
    redirectToPostTulerUrl() {
      if(this.generalSetting.redirectPageToApply) {
        window.location.replace(this.generalSetting.redirectPageToApply)
      }
    }
  },
};
